// extracted by css-extract-rspack-plugin
export default {"main":"Presenter__main--LT5eQ","section":"Presenter__section--J5EPK","category":"Presenter__category--aVSQr","list":"Presenter__list--LPC9B","subText":"Presenter__subText--WZxtO"};